// export const PRIMARY = '#06623B';

export const colors = {
    PRIMARY: '#06623B'
}